<footer class="footer">
  AsanSka University College of Design and Technology | Copyright © {{today | date: 'yyyy'}}
</footer>
